module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_diamonds-4.96e4a5d1.svg";